var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApexChart',{attrs:{"type":_vm.chartType,"options":_vm.chartOptions,"series":_vm.value,"width":"100%","height":"415px"}})}
var staticRenderFns = []

export { render, staticRenderFns }